module.exports = __webpack_public_path__ + "static/img/5.496bb97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/5.png
// module id = 9AL5
// module chunks = 0